import axios from 'axios'

export default {
  state: () => ({
    users: [],
    activeUser: null,
  }),
  getters: {
    getAll: (state) => state.users,
    getActive: (state) => state.activeUser,
  },
  mutations: {
    setUsers(state, users) {
      state.users = users
    },
    setActiveUser(state, user) {
      state.activeUser = user
    },
    resetActiveUser(state) {
      state.activeUser = null
    },
    deleteUser(state, userId) {
      const temp = state.users
      const userIndexToDelete = state.users.findIndex(user => user.id === userId)

      if (userIndexToDelete >= 0) {
        temp.splice(userIndexToDelete, 1)
      }

      state.users = temp
    }
  },
  actions: {
    async fetchAll({ commit, rootState }) {
      const users = (await axios.get("/users")).data
      commit("setUsers", users)
    },
    async fetchById({ commit, rootState }, userId) {
      const user = (await axios.get(`/users/${userId}`)).data
      commit("setActiveUser", user)
    },
    async delete({ commit, rootState }, userId) {
      await axios.delete(`/users/${userId}`)
      commit("deleteUser", userId)
    },
    get_users: async function ({ commit }) {
      return await axios.get(`/users`).then((users) => {
        return users.data
      })
    },
    addUsersToGroup: function ({ commit }, { group_id, members }) {
      return axios.post(`/groups/${group_id}/members/add`, members).then((group) => {
    return group
      })
    },
  }
}
